import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaStar } from "react-icons/fa";

const FeedbackModal = ({ onClose, onSubmit }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [hover, setHover] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [showGoogleFeedback, setShowGoogleFeedback] = useState(false);

  const handleSubmit = () => {
    if (rating === 0) {
      alert("Please provide a rating");
      return;
    }
    onSubmit(rating, comment);
    setSubmitted(true);

    if (rating >= 4) {
      setShowGoogleFeedback(true);
    } else {
      onClose();
    }
  };

  return (
    <Modal 
      show={true} 
      onHide={() => {}}
      centered 
      backdrop="static"  
      keyboard={false} 
    >
      <Modal.Header>
        <Modal.Title>Feedback</Modal.Title>
        {/* Close button removed */}
      </Modal.Header>
      <Modal.Body>
        {!submitted ? (
          <Form>
            <Form.Group className="mb-3 text-center">
              <Form.Label className="fw-bold">Rate Your Experience</Form.Label>
              <div className="star-rating d-flex justify-content-center">
                {[...Array(5)].map((_, i) => {
                  const ratingValue = i + 1;
                  return (
                    <label key={i} className="star-label">
                      <input
                        type="radio"
                        name="rating"
                        value={ratingValue}
                        onClick={() => setRating(ratingValue)}
                        style={{ display: "none" }}
                      />
                      <FaStar
                        className="star"
                        color={ratingValue <= (hover || rating) ? "#ffc107" : "#e4e5e9"}
                        size={35}
                        onMouseEnter={() => setHover(ratingValue)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(ratingValue)}
                        style={{ cursor: "pointer", transition: "color 0.2s" }}
                      />
                    </label>
                  );
                })}
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Additional Comments</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Tell us about your experience..."
                className="rounded shadow-sm"
              />
            </Form.Group>
          </Form>
        ) : showGoogleFeedback ? (
          <div className="text-center">
            <h5>Thank you for your feedback!</h5>
            <a 
              href="https://search.google.com/local/writereview?placeid=ChIJc03yYGCFXjkR5jCfhWzx_uQ" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary mt-3"
            >
              Leave a Google Review
            </a>
            <Button 
              variant="link" 
              onClick={onClose}
              className="d-block mx-auto mt-2"
            > 
              Maybe Later
            </Button>
          </div>
        ) : (
          <div className="text-center">
            <h5>Thank you for your feedback!</h5>
            <p>We appreciate you helping us improve our service.</p>
            <Button 
              variant="primary" 
              onClick={onClose}
              className="mt-3"
            >
              Close
            </Button>
          </div>
        )}
      </Modal.Body>

      {!submitted && (
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="primary" onClick={handleSubmit} className="rounded-pill px-4">
            Submit Feedback
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default FeedbackModal;

